enum CreativeType {
  VIDEO = 'video',
  VIDEO_VAST = 'video_vast',
  DISPLAY = 'display',
  DISPLAY_TAG = 'display_tag',
  HTML5 = 'html5',
  AUDIO = 'audio',
  AUDIO_VAST = 'audio_vast',
  YOUTUBE_LINK = 'youtube_link',
}

export default CreativeType;
